'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBaseOptions = undefined;
var _ramda = require('ramda');
var R = _interopRequireWildcard(_ramda);
var _constants = require('../constants');
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
var getBaseOptions = exports.getBaseOptions = function getBaseOptions(type, options) {
  return R.pipe(R.propOr({}, 'base'), R.cond([[R.always(R.equals(_constants.BAR, type)), R.mergeDeepRight({
    minDisplayHeight: 100,
    minDisplayWidth: 300,
    padding: {
      top: 20
    },
    innerPadding: {
      left: 20,
      right: 20,
      bottom: 10
    }
  })], [R.always(R.equals(_constants.ROW, type)), R.mergeDeepRight({
    minDisplayHeight: 300,
    minDisplayWidth: 100,
    padding: {
      top: 10,
      left: 10,
      right: 20
    }
  })], [R.always(R.equals(_constants.SCATTER, type)), R.mergeDeepRight({
    minDisplayHeight: 100,
    minDisplayWidth: 100,
    padding: {
      top: 40,
      right: 10
    }
  })], [R.always(R.equals(_constants.TIMELINE, type)), R.mergeDeepRight({
    minDisplayHeight: 300,
    minDisplayWidth: 100,
    isAnnotated: false,
    padding: {
      top: 20
    },
    innerPadding: {
      left: 40,
      right: 40
    }
  })], [R.always(R.equals(_constants.H_SYMBOL, type)), R.mergeDeepRight({
    minDisplayHeight: 300,
    minDisplayWidth: 100,
    padding: {
      top: 10,
      left: 10,
      right: 20
    }
  })], [R.always(R.equals(_constants.V_SYMBOL, type)), R.mergeDeepRight({
    minDisplayHeight: 100,
    minDisplayWidth: 300,
    padding: {
      top: 20
    },
    innerPadding: {
      left: 20,
      right: 20,
      bottom: 10
    }
  })], [R.always(R.equals(_constants.STACKED_BAR, type)), R.mergeDeepRight({
    minDisplayHeight: 100,
    minDisplayWidth: 300,
    padding: {
      top: 20
    },
    innerPadding: {
      left: 20,
      right: 20,
      bottom: 10
    }
  })], [R.always(R.equals(_constants.STACKED_ROW, type)), R.mergeDeepRight({
    padding: {
      top: 10,
      left: 10,
      right: 20
    }
  })], [R.T, R.identity]]))(options);
};